export type Config = {
  contracts: { readonly [key: string]: string };
  apiGatewayUrl: string;
  mediaServiceUrl?: string;
  documentsUrl?: string;
  googleMapsKey?: string;
  middlewareUrl?: string;
};

let apiGatewayUrl: Config["apiGatewayUrl"] =
  "https://staging.api-gateway.campgladiator.com";

let mediaServiceUrl: Config["mediaServiceUrl"] =
  "https://media-service-27gvudja7q-uc.a.run.app";

let documentsUrl: Config["documentsUrl"] =
  "https://staging-web.campgladiator.com/api/retrieve-contract";

let googleMapsKey: Config["googleMapsKey"] =
  "AIzaSyDx5N92YCuMYWSYV0z2dJ4AJWLZ_2PTVG0";

let middlewareUrl: Config["middlewareUrl"] =
  "https://staging-web.campgladiator.com/api";

export const contracts: Config["contracts"] = {
  camp: `${documentsUrl}?type=camp`,
  nutrition: `${documentsUrl}?type=nutrition`,
  strength: `${documentsUrl}?type=strength`,
  boldBig5: `${documentsUrl}?type=boldBig5`,
};

export const setApiGatewayUrl = (url: string) => (apiGatewayUrl = url);
export const getApiGatewayUrl = () => apiGatewayUrl;
export const setMediaServiceUrl = (url: string) => (mediaServiceUrl = url);
export const getMediaServiceUrl = () => mediaServiceUrl;
export const setDocumentsUrl = (url: string) => (documentsUrl = url);
export const getDocumentsUrl = () => documentsUrl;
export const setGoogleMapsKey = (key: string) => (googleMapsKey = key);
export const getGoogleMapsKey = () => googleMapsKey;
export const setMiddlewareUrl = (url: string) => (middlewareUrl = url);
export const getMiddlewareUrl = () => middlewareUrl;
